import React from "react";
import "./style.css";

const ProcessTypeToggle = ({ value, onChange }) => {
  return (
    <div className="process-type-toggle">
      <label className="toggle-label">İşlem Türü</label>

      <div className="toggle-buttons">
        <button
          className={value === "error" ? "toggle-btn active" : "toggle-btn"}
          onClick={() => onChange("error")}
        >
          Satın Alma Hatası
        </button>

        <button
          className={value === "on-call" ? "toggle-btn active" : "toggle-btn"}
          onClick={() => onChange("on-call")}
        >
          Telefon ile Satış Talebi
        </button>
      </div>

      {!value && <p className="warning-text">Lütfen işlem türünü seçiniz.</p>}
    </div>
  );
};

export default ProcessTypeToggle;
